<template>
  <Wrapper>
    <Header />
    <Content />
    <Footer />
    <DebugApp :debugURL="debugURL" />
  </Wrapper>
</template>

<script lang="ts">
import DebugApp from "@fresh8/debug-kit/src/App.vue";
import { defineComponent, watchEffect } from "vue";
import * as Sentry from "@sentry/browser";

import Wrapper from "./components/Wrapper.vue";
import Header from "./components/Header.vue";
import Footer from "./components/Footer.vue";
import Content from "./components/Content.vue";
import { AnalyticEvents } from "./types/analytics";

import {
  createLayoutContext,
  provideLayoutSync
} from "@fresh8/vue-utils/src/dimensionSync";

import { useHandleAnalytics } from "./lib/analytics";
import Properties from "./properties";
import { useBetData } from "./hooks/useBetData";

export default defineComponent({
  components: {
    Wrapper,
    Header,
    Content,
    Footer,
    DebugApp
  },
  setup() {
    const $handleAnalytics = useHandleAnalytics();

    provideLayoutSync(createLayoutContext());

    $handleAnalytics(AnalyticEvents.VIEWED, "Impression");
    const betData = useBetData();

    watchEffect(() => {
      Sentry.configureScope(scope => {
        scope.setTag("catalogId", betData.catalogId.value);
        scope.setTag("campaignId", betData.campaignId.value);
        scope.setTag("viewId", betData.viewId.value);
      });
    });

    return {
      debugURL: Properties.debugUri
    };
  }
});
</script>
